<template>
  <div class="op--modal-container">
    <div class="op--modal">
      <div class="op--modal-content">
        <div class="header bg-color" v-if="type==''">
          <span>{{ $t('driverReview.thankYou') }}</span>
        </div>
        <div class="driver-review">
          <div v-if="type=='error'" class="error">
            <div class="error-icon">
              <i class="fas fa-exclamation-circle"></i>
            </div>
            <div class="message">{{typeMessage || 'Error'}}</div>
            <div class="ok-btn">
              <button class="op-btn btn-lg btn-block" @click="cancel">{{ $t('driverReview.ok') }}</button>
            </div>
          </div>
          <div v-else-if="type=='success'" class="success">
            <div class="success-icon">
              <i class="fas fa-check-circle"></i>
            </div>
            <div class="message">
              <span class="thanks">{{ $t('driverReview.thankYouRating') }}</span>
              <br />{{ $t('driverReview.feedback') }}
            </div>
            <div class="ok-btn">
              <button class="op-btn btn-lg btn-block" @click="cancel">{{ $t('driverReview.ok') }}</button>
            </div>
          </div>
          <div v-else class="review">
            <div class="content">
              <div class="pic">
                <img :src="driver.avatarUrl" alt="driver-pic" />
              </div>
              <span class="driver-name">{{driver.firstName || ''}}</span>
              <div v-if="review.value > 0" class="reviewed">
                <div class="stars">
                  <span class="star hovered" v-for="n in review.value" :key="n">
                    <i class="fas fa-star"></i>
                  </span>
                  <span class="star" v-for="n in (5 - review.value)" :key="5+n">
                    <i class="fas fa-star"></i>
                  </span>
                </div>
                <span class="rating" v-if="review.value==1">{{ $t('driverReview.poor') }}</span>
                <span class="rating" v-else-if="review.value==2">{{ $t('driverReview.fair') }}</span>
                <span class="rating" v-else-if="review.value==3">{{ $t('driverReview.average') }}</span>
                <span class="rating" v-else-if="review.value==4">{{ $t('driverReview.good') }}</span>
                <span class="rating" v-else-if="review.value==5">{{ $t('driverReview.execellent') }}</span>
                <div class="comment">
                  <textarea :placeholder="review.message" disabled></textarea>
                </div>
                <div class="footer">
                  <button class="op-btn btn-success btn-lg btn-block" @click="cancel">{{ $t('driverReview.ok') }}</button>
                </div>
              </div>
              <div v-else>
                <div class="stars">
                  <span
                    id="1star"
                    class="star"
                    @mouseover="hoverStar($event)"
                    @mouseleave="removeHovered($event)"
                    @click="rate($event)"
                  >
                    <i class="fas fa-star"></i>
                  </span>
                  <span
                    id="2star"
                    class="star"
                    @mouseover="hoverStar($event)"
                    @mouseleave="removeHovered($event)"
                    @click="rate($event)"
                  >
                    <i class="fas fa-star"></i>
                  </span>
                  <span
                    id="3star"
                    class="star"
                    @mouseover="hoverStar($event)"
                    @mouseleave="removeHovered($event)"
                    @click="rate($event)"
                  >
                    <i class="fas fa-star"></i>
                  </span>
                  <span
                    id="4star"
                    class="star"
                    @mouseover="hoverStar($event)"
                    @mouseleave="removeHovered($event)"
                    @click="rate($event)"
                  >
                    <i class="fas fa-star"></i>
                  </span>
                  <span
                    id="5star"
                    class="star"
                    @mouseover="hoverStar($event)"
                    @mouseleave="removeHovered($event)"
                    @click="rate($event)"
                  >
                    <i class="fas fa-star"></i>
                  </span>
                </div>
                <span :class="{'rating zero':true, 'error':isRequired}" v-if="rating===0">{{ $t('driverReview.rateRide') }}</span>
                <span class="rating" v-else-if="rating==1">{{ $t('driverReview.poor') }}</span>
                <span class="rating" v-else-if="rating==2">{{ $t('driverReview.fair') }}</span>
                <span class="rating" v-else-if="rating==3">{{ $t('driverReview.average') }}</span>
                <span class="rating" v-else-if="rating==4">{{ $t('driverReview.good') }}</span>
                <span class="rating" v-else-if="rating==5">{{ $t('driverReview.execellent') }}</span>
                <div class="comment">
                  <textarea :placeholder="$t('driverReview.writeComments')" v-model="comment"></textarea>
                </div>
                <div class="footer">
                  <button :class="{'op-btn btn-success btn-lg btn-block ':true, 'disabled':isLoading}" @click="submit">
                    <i class="fas fa-spinner fa-spin slow-spin" v-if="isLoading"></i> {{ $t('common.submit') }}
                  </button>
                  <div @click="cancel" class="cancel">
                    <a href="/">{{ $t('common.cancel') }}</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiRsvp from '@/modules/api/reservation-search'

export default {
  name: 'driver-review',
  data: function () {
    return {
      type: '',
      typeMessage: '',
      hasReview: false,
      isLoading: false,
      isRequired: false,
      rating: 0,
      comment: ''
    }
  },
  computed: {
    driver () { return this.$store.state.driverReview.driverInfo },
    review () { return this.$store.state.driverReview.rating }
  },
  methods: {
    hoverStar (star) {
      let count = star.currentTarget.id[0]
      for (let i = 1; i <= 5; i++) {
        if (i <= count) {
          document.getElementById(i + 'star').classList.add('hovered')
        }
      }
    },
    removeHovered (star) {
      let count = star.currentTarget.id[0]
      for (let i = 1; i <= 5; i++) {
        if (i <= count) {
          document.getElementById(i + 'star').classList.remove('hovered')
        }
      }
    },
    rate (star) {
      for (let i = 1; i <= 5; i++) {
        document.getElementById(i + 'star').classList.remove('rated')
      }
      let count = star.currentTarget.id[0]
      for (let i = 1; i <= 5; i++) {
        if (i <= count) {
          document.getElementById(i + 'star').classList.add('rated')
        }
      }
      this.rating = count
    },
    submit () {
      let self = this
      if (self.rating === 0) {
        self.isRequired = true
        setTimeout(() => { self.isRequired = false }, 3000)
        return
      }
      if (self.isLoading) return
      self.isLoading = true
      let params = this.$store.state.driverReview.rsvpParams
      ApiRsvp.saveReview(self, params.id, params.firstName, params.lastName, self.rating, self.comment, res => {
        if (!res.error) {
          this.type = 'success'
        } else {
          this.type = 'error'
          this.typeMessage = res.error.message
        }
      })
    },
    cancel () {
      window.location.href = window.location.origin
    }
  }
}
</script>

<style lang="scss" scoped>
.op--modal-container {
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  background-color: rgba(0, 0, 0, 0.5);
}

.header {
  max-width: 400px;
  margin: 10px auto;
  margin-bottom: 0;
  text-align: center;
  color: #fff;
  padding: 15px;
  span {
    font-size: 21px;
    font-weight: 600;
  }
}

.driver-review {
  background-color: #fff;
  max-width: 400px;
  margin: 10px auto;
  margin-top: 0;
  border-radius: 3px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  font-family: "Questrial", sans-serif;
  text-align: center;
  padding: 30px;

  .review {
    .pic img {
      border-radius: 50%;
      height: 180px;
      width: 180px;
    }

    .driver-name {
      color: #666;
      font-size: 17px;
    }

    .rating {
      font-weight: 600;
      &.zero {
        font-weight: 500;
      }
      &.error {
        color: red;
      }
    }

    .stars {
      padding: 20px 0;
      .star {
        i {
          font-size: 40px;
          color: #e0e0e0;
          margin: 0 2px;
          cursor: pointer;
        }
        &.hovered,
        &.rated {
          i {
            color: #ffcd00;
          }
        }
      }
    }

    .comment textarea {
      width: 100%;
      resize: none;
      padding: 10px;
      height: 100px;
      border-color: #bbb;
      margin: 20px 0;
      font-size: 14px;
    }

    .footer {
      .cancel {
        display: inline-block;
        margin-top: 10px;
        cursor: pointer;
        font-size: 15px;
        a {
          color: #2c3e50 !important;
        }
      }
    }

    .reviewed {
      .star i {
        cursor: default;
      }
    }

    textarea:disabled {
      background-color: #fff;
      color: #2c3e50;
      cursor: not-allowed;
    }
  }

  .error,
  .success {
    .error-icon i {
      font-size: 100px;
      color: red;
    }
    .success-icon i {
      font-size: 100px;
      color: green;
    }
    .message {
      padding: 20px 0;
      font-size: 16px;
      .thanks {
        font-weight: 600;
      }
    }
  }
}

@media (max-width: 650px) {
  .op--modal {
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// index.vue?14d10581